<template>
  <div class="tw-relative tw-z-50 tw-w-full tw-bg-gray-100">
    <div class="tw-container tw-mx-auto tw-px-4">
      <q-tabs no-caps align="left">
        <q-route-tab
          v-for="(item, key) in items"
          :key="key"
          :to="{
            name: item.name,
          }"
        >
          <div class="tw-flex tw-items-start tw-gap-1">
            {{ generateMenuTitle(item) }}
            <span class="tw-text-xs tw-italic" v-if="item.meta.sublabel">
              {{ generateMenuTitle(item, "sublabel") }}</span
            >
          </div>
        </q-route-tab>
      </q-tabs>
    </div>
  </div>
</template>

<script setup>
import useHelpers from "composables/useHelpers";

const { generateMenuTitle } = useHelpers();

defineProps({
  items: {
    type: Array,
    required: true,
  },
});
</script>

<style lang="scss">
.q-tabs--horizontal {
  .q-tabs__arrow {
    height: unset !important;

    &--left,
    &--right {
      top: 4px !important;
      bottom: 4px !important;
    }
  }
}
</style>
